import profileImage from "../../images/profile.jpg";
import { Formik } from "formik";
import * as Yup from "yup";
import Input from "../../components/input";
import Button from "../../components/button";
import { useEffect, useMemo, useRef, useState } from "react";
import { doc, setDoc } from "firebase/firestore";
import { auth, db } from "src/firebase/firebase";
import { handleToastMessage } from "src/js/handleToastMessage";
import SideBar from "../../components/sidebar/sidebar";
import { useTranslation } from "react-i18next";
import { excludedCountries } from "../signup/signup";
import countryList from "react-select-country-list";
import Tooltip from "@mui/material/Tooltip";
import infoIcon from "../../assets/icons/info.png";
import Select from "../../components/select/select";

const validationSchema = Yup.object().shape({
  id: Yup.string(),

  firstName: Yup.string().required("First name is required."),
  lastName: Yup.string().required("Last name is required."),
  email: Yup.string().email().trim().required("Email is required."),
  // addressLine1: Yup.string(),
  // addressLine2: Yup.string(),
  // usdtAddress: Yup.string(),
  country: Yup.string().required("Country is required"),
});
const initialValues = {
  id: "",
  firstName: "asdf",
  lastName: "",
  email: "",
  country: "",
  // addressLine1: "",
  // addressLine2: "",
  // usdtAddress: "",
  // profileImage: "",
};

const Profile = ({
  isShowSideBar = true,
  user = null,
  updateProfile = (value: boolean) => {},
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation(["home"]);

  const isAdmin = useMemo(() => {
    let _data = localStorage.getItem("account");
    return user
      ? user.accountType === "admin"
      : JSON.parse(_data).accountType === "admin" ?? false;
  }, [user]);

  const isSupplier = useMemo(() => {
    let _data = localStorage.getItem("account");
    return user
      ? user.accountType === "supplier"
      : JSON.parse(_data).accountType === "supplier" ?? false;
  }, [user]);

  const initValue = useMemo(() => {
    let _data = localStorage.getItem("account");
    return user ?? JSON.parse(_data) ?? initialValues;
  }, [user]);

  const filteredOptions = useMemo(() => {
    const allCountries = countryList().getData();
    const filteredCountries = allCountries.filter(
      (country) => !excludedCountries.includes(country.value.toLowerCase())
    );
    return filteredCountries;
  }, []);
  const hiddenFileInput = useRef(null);

  const handleClick = () => {
    hiddenFileInput && hiddenFileInput?.current?.click();
  };

  const handleUpdateProfile = async (values: any) => {
    setIsLoading(true);
    if (!user) {
      localStorage.setItem("account", JSON.stringify(values));
    }
    await setDoc(doc(db, "Accounts", values.id), values);
    setIsLoading(false);

    handleToastMessage("success", "Update profile successfully");
    if (user) {
      updateProfile?.(true);
    }
  };

  return (
    <div className="flex mt-16">
      {isShowSideBar && <SideBar supplier={isSupplier} admin={isAdmin} />}
      <main className="w-full overflow-hidden">
        <div className="p-5">
          <div className="flex justify-between items-center mb-3">
            <h2 className="text-xl text-darkBlack font-semibold">
              {t("Profile")} {t("Settings")}
            </h2>
          </div>
          <div className="bg-white">
            <div className="flex justify-between items-center border-b py-3 px-3">
              <h1 className="text-darkGrey text-lg font-bold ">
                {t("Settings")}{" "}
              </h1>
              <h1 className="text-darkGrey text-lg font-bold text-sm ">
                {t("Your Account Limit")}:{" "}
                <span className="text-blue">${initValue.accountLimit}</span>
              </h1>
            </div>
            {Object.keys(initValue).length > 0 && (
              <Formik
                initialValues={initValue}
                validationSchema={validationSchema}
                onSubmit={handleUpdateProfile}
                validateOnBlur
              >
                {({
                  values,
                  errors,
                  touched,
                  handleSubmit,
                  setFieldTouched,
                  setFieldValue,
                  isSubmitting,
                  handleChange,
                  handleBlur,
                }) => {
                  console.log("values", values);
                  // const handeImage = (event: any) => {
                  //   const fileUploaded = event.target.files[0];
                  //   var reader = new FileReader();
                  //   reader.onloadend = function () {
                  //     setFieldTouched("profileImage", true);
                  //     setFieldValue("profileImage", reader.result);
                  //   };
                  //   reader.readAsDataURL(fileUploaded);
                  // };
                  return (
                    <div className="flex ">
                      {/* <div className="border-r px-4 pt-4 pb-4">
                        <span className="text-semibold">
                          {t("Profile")} {t("Image")}
                        </span>
                        <img
                          alt=""
                          src={values.profileImage ?? ""}
                          className="h-[200px] w-[200px] rounded mt-2"
                        />
                        <p
                          onClick={handleClick}
                          className="text-xs underline font-semibold underline text-blue mt-2 cursor-pointer"
                        >
                          {t("Choose a file")}
                        </p>
                        <input
                          type="file"
                          ref={hiddenFileInput}
                          accept="image/*"
                          onChange={handeImage}
                          style={{ display: "none" }}
                        />
                      </div> */}
                      <div className="p-4 flex-1">
                        <form onSubmit={handleSubmit}>
                          <div>
                            <div className="flex gap-2 mb-4">
                              <Input
                                label={t("First Name")}
                                className="flex-1"
                                placeholder={t("First Name")}
                                name="firstName"
                                value={values.firstName}
                                error={errors.firstName}
                                touched={touched.firstName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                variant="solid"
                              />
                              <Input
                                className="flex-1"
                                label={t("Last Name")}
                                containerClass="w-full"
                                placeholder={t("Last Name")}
                                name="lastName"
                                value={values.lastName}
                                error={errors.lastName}
                                touched={touched.lastName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                variant="solid"
                              />
                            </div>
                            {/* <div className="flex gap-2 mb-4">
                          <Input
                            labelClassName="mt-3 text-base font-medium inline-block"
                            label="Current Password"
                            className="flex-1"
                            placeholder="Current Password"
                            name="password"
                            type="password"
                            error={errors.password}
                            touched={touched.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            variant="solid"
                          />
                          <Input
                            labelClassName="mt-3 text-base font-medium inline-block"
                            label="New Password"
                            className="flex-1"
                            placeholder="New Password"
                            name="newPassword"
                            type="password"
                            error={errors.newPassword}
                            touched={touched.newPassword}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            variant="solid"
                          />
                        </div>
                        <Input
                          labelClassName="mt-3 text-base font-medium inline-block"
                          label="Repeat Password"
                          className="flex-1"
                          placeholder="Repeat Password"
                          name="repeatPassword"
                          type="password"
                          error={errors.repeatPassword}
                          touched={touched.repeatPassword}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          variant="solid"
                        /> */}
                            <Input
                              labelClassName=" mt-3 text-base font-medium inline-block"
                              label={t("Email ID")}
                              containerClass="w-full"
                              readOnly
                              placeholder={t("Email ID")}
                              name="email"
                              error={errors.email}
                              value={values.email}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={touched.email}
                              variant="solid"
                            />
                            {/* <Input
                              labelClassName=" mt-3 text-base font-medium inline-block"
                              label={t("Address Line 1 (Optional)")}
                              containerClass="w-full"
                              placeholder={t("Address line 1")}
                              name="addressLine1"
                              error={errors.addressLine1}
                              value={values.addressLine1}
                              touched={touched.addressLine1}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              variant="solid"
                            />
                            <Input
                              labelClassName=" mt-3 text-base font-medium inline-block"
                              label={t("Address Line 2 (Optional)")}
                              containerClass="w-full"
                              placeholder={t("Address line 2")}
                              name="addressLine1"
                              error={errors.addressLine2}
                              value={values.addressLine2}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={touched.addressLine2}
                              variant="solid"
                            />
                            <Input
                              labelClassName=" mt-3 text-base font-medium inline-block"
                              label={t("BTC/USDT Address (Optional)")}
                              containerClass="w-full"
                              placeholder={t("BTC/USDT Address")}
                              name="usdtAddress"
                              error={errors.usdtAddress}
                              value={values.usdtAddress}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={touched.usdtAddress}
                              variant="solid"
                            /> */}
                          </div>
                          <div className="mb-3 mt-4">
                            <div className="flex gap-2">
                              <label className="mb-2 text-sm font-semibold inline-block">
                                {t("Select country")}
                              </label>
                              <Tooltip
                                title="Exclude OFAC sanctioned countries"
                                placement="top"
                              >
                                <img
                                  src={infoIcon}
                                  className="h-[25px] w-[25px] cursor-pointer"
                                  alt="info"
                                />
                              </Tooltip>
                            </div>
                            <Select
                              options={filteredOptions}
                              placeholder="Select country"
                              onChange={(value: any) => {
                                setFieldTouched("country", true);
                                setFieldValue("country", value?.value);
                              }}
                              value={
                                filteredOptions.find(
                                  (item) =>
                                    item?.value?.toLowerCase() ===
                                    values?.country?.toLowerCase()
                                ) ?? null
                              }
                            />
                            {touched.country && errors.country && (
                              <p className="my-2 text-xs text-start text-red">
                                {errors && (errors.country as any)}
                              </p>
                            )}
                          </div>
                          <div className="flex justify-end">
                            <Button
                              className="ml-0 block   bg-blue mt-4 mb-3"
                              loading={isLoading}
                              type="submit"
                            >
                              {t("Update")}
                            </Button>
                          </div>
                        </form>
                      </div>
                    </div>
                  );
                }}
              </Formik>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};
export default Profile;
